import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../utils/api";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Routes, Route, useParams } from "react-router-dom";
import { getOrderStatuses } from "../utils/api.js";
import { format } from "date-fns";

const ViewOrderLayer = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [orderInfo, setOrderInfo] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);

  async function fetchOrderInfo() {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "order-details/" + id)
      .then((res) => {
        // return false;
        if (res.data) {
          console.log("red data", res.data);
          setOrderInfo(res.data);
        } else {
          toast.success("something went wrong...");
        }
      })
      .catch((err) => {
        console.error(err);
        alert(err);
      });
    let statuses = await getOrderStatuses();
    setOrderStatuses(statuses);
  }

  useEffect(() => {
    fetchOrderInfo();
  }, []);
  const [servicesList, setServicesList] = useState([]);
  const [locationsList, setLocationsList] = useState({
    1: "Liverpool, NSW",
    2: "Drummoyne, NSW",
  });

  useLayoutEffect(() => {
    // Fetch data
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "service-list")
      .then((response) => {
        const servicedata = response.data.data;
        let servicearray = [];

        servicedata.map((srvc, index) => (servicearray[srvc.id] = srvc.title));
        setServicesList(servicearray);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []); // Re-run this effect when posts change
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  const sepaymentStatuses = [
    "pending",
    "Assigned",
    "Service Started",
    "Payment Pending",
    "Paid and Closed",
  ];

  function renderHTML(escapedHTML) {
    return React.createElement("div", {
      dangerouslySetInnerHTML: { __html: escapedHTML },
    });
  }

  function fetchLableVal(key, val) {
    switch (key) {
      case "createdAt":
      case "updatedAt":
      case "serviceDate":
            return (
            <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {formatDate(val)}
          </>
        );
      case "serviceId":
        return (
          <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {servicesList[val]}
          </>
        );
      case "branch":
        return (
          <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {locationsList[val]}
          </>
        );
      case "serviceStatus":
        return (
          <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {orderStatuses[val]}
          </>
        );
      case "paymentStatus ":
        return (
          <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {val ? "Pending" : "Closed"}
          </>
        );
      default:
        return (
          <>
            <label
              className="form-label fw-bold text-neutral-900"
              htmlFor="title"
            >
              {key} :{" "}
            </label>
            {val != "" ? val : "N/A"}
          </>
        );
    }
  }

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card mt-24">
          <div className="card-header border-bottom">
            <h6 className="text-xl mb-0">Service Details</h6>
          </div>
          <div className="card-body p-24">
            {orderInfo &&
              Object.keys(orderInfo).map((key) => {
                return (
                  <div>
                    {fetchLableVal(key, orderInfo[key])}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOrderLayer;
